<template>
  <section :key="'cer' + $route.path">
    <v-layout row class="mt-4">
      <v-flex xs12 md1>
        <v-text-field
          outlined
          @change="obtenerMuestras()"
          label="Folio"
          v-model="filtros.MuestraDetalleID"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md2>
        <v-autocomplete
          @change="obtenerMuestras()"
          outlined
          label="Estado"
          item-value="CertificadoEstadoID"
          item-text="CertificadoEstado"
          :items="catalogos.CertificadosEstados"
          v-model="filtros.CertificadoEstadoID"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 md2>
        <v-text-field
          outlined
          @change="obtenerMuestras()"
          label="Nombre Paciente"
          v-model="filtros.PacienteNombre"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 md2>
        <v-menu
          ref="fechaInicio"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-on="on"
              label="Fecha Inicio"
              slot="activator"
              :value="formatDate(filtros.FechaInicial)"
              prepend-icon="event"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            @change="obtenerMuestras()"
            @input="$refs.fechaInicio.save(filtros.FechaInicial)"
            locale="es-es"
            v-model="filtros.FechaInicial"
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md2>
        <v-menu
          ref="fechaFin"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-on="on"
              label="Fecha Fin"
              slot="activator"
              :value="formatDate(filtros.FechaFinal)"
              prepend-icon="event"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            @change="obtenerMuestras()"
            @input="$refs.fechaFin.save(filtros.FechaFinal)"
            locale="es-es"
            v-model="filtros.FechaFinal"
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md3 class="text-right">
        <v-btn
          v-if="citasSeleccionadas.length"
          large
          color="primary"
          @click.prevent="enviarResultados(null)"
          class="mr-5"
        >
          <v-icon>send</v-icon> Enviar Resultados
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card>
      <v-card-text>
        <v-simple-table fixed-header height="660px">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="50"></th>
                <th class="text-left primary--text">
                  Folio
                </th>
                <th class="text-left primary--text">
                  Convenio
                </th>
                <th class="text-left primary--text">
                  Cliente
                </th>
                <th class="text-left primary--text">
                  Fecha
                </th>
                <th class="text-left primary--text">
                  Hora
                </th>
                <th class="text-left primary--text">
                  Análisis
                </th>
                <th class="text-center primary--text">
                  Aprobación
                </th>
                <th></th>
                <th width="50"></th>
              </tr>
            </thead>
            <tbody v-if="!citas.length">
              <td colspan="5">
                <div class="ma-3">
                  No se encontraron muestras
                </div>
              </td>
            </tbody>

            <tbody>
              <template v-for="cita in citas">
                <tr
                  @click.prevent="seleccionarCita(cita, $event)"
                  :key="cita.MuestraID"
                  class="link"
                >
                  <td>
                    <v-checkbox
                      :disabled="
                        cita.Personas &&
                          cita.Personas.length &&
                          !cita.Personas.some((p) => p.EsAprobado === 1)
                      "
                      @change="seleccionCambiada"
                      v-model="cita.Seleccionado"
                      class="chk"
                    ></v-checkbox>
                  </td>
                  <td>
                    {{ cita.Personas.length > 1 ? "" : cita.MuestraDetalleID }}
                  </td>
                  <td>
                    {{
                      cita.Personas.length > 1
                        ? " "
                        : cita.ConvenioNombre
                    }}
                  </td>
                  <td>
                    {{
                      cita.Personas.length > 1
                        ? cita.ConvenioNombre +
                          " (" +
                          cita.Personas.length +
                          " muestras)"
                        : cita.Nombres + " " + cita.PrimerApellido
                    }}
                  </td>
                  <td>
                    <template v-if="!cita.Personas || cita.Personas.length <= 1"
                      >{{ fechaSQL(cita.FechaMuestra) }}
                    </template>
                  </td>
                  <td>
                    <template
                      v-if="!cita.Personas || cita.Personas.length <= 1"
                    >
                      {{ horaSQL(cita.FechaMuestra) }}
                    </template>
                  </td>
                  <td>
                    <template v-if="!esConvenio(cita)">
                      {{ cita.AnalisisTipo }}
                    </template>
                  </td>
                  <td class="text-center">
                    <v-icon
                      color="success"
                      v-if="
                        (esConvenio(cita) &&
                          !cita.Personas.some((p) => p.EsAprobado === 0)) ||
                          (!esConvenio(cita) && cita.EsAprobado === 1)
                      "
                      >done</v-icon
                    >
                    <v-icon
                      color="yellow"
                      v-if="
                        (esConvenio(cita) &&
                          cita.Personas.some((p) => p.EsAprobado === 0)) ||
                          (!esConvenio(cita) && cita.EsAprobado === 0)
                      "
                      >schedule</v-icon
                    >
                  </td>
                  <td class="text-right">
                    <v-tooltip bottom v-if="!esConvenio(cita) && cita.Archivo">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          @click.prevent="verResultados(cita)"
                        >
                          <v-icon color="primary">visibility</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver Resultados</span>
                    </v-tooltip>
                    <v-tooltip
                      bottom
                      v-if="
                        (!esConvenio(cita) &&
                          cita.EsAprobado === 1 &&
                          !!cita.Archivo) ||
                          (esConvenio(cita) &&
                            cita.Personas.some(
                              (p) => p.EsAprobado === 1 && !!p.Archivo
                            ))
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="ml-2"
                          icon
                          @click.prevent="enviarResultados(cita)"
                        >
                          <v-icon color="primary">email</v-icon>
                        </v-btn>
                      </template>
                      <span>Enviar Resultados</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <template v-if="cita.Personas.length > 1">
                      <v-icon class="ml-2" v-if="!!expDict[cita.CitaID]"
                        >expand_more</v-icon
                      >
                      <v-icon class="ml-2" v-else>chevron_right</v-icon>
                    </template>
                  </td>
                </tr>
                <template v-if="cita.Personas.length > 1">
                  <tr
                    v-show="!!expDict[cita.CitaID]"
                    v-for="persona in cita.Personas"
                    :key="'p' + persona.MuestraDetalleID"
                    class="link subtabla"
                  >
                    <td></td>
                    <td>{{ persona.MuestraDetalleID }}</td>
                    <td>{{ persona.ConvenioNombre }}</td>
                    <td>
                      {{
                        persona.Nombres || persona.PrimerApellido
                          ? persona.Nombres + " " + persona.PrimerApellido
                          : " - "
                      }}
                    </td>
                    <td>{{ fechaSQL(persona.FechaMuestra) }}</td>
                    <td>{{ horaSQL(persona.FechaMuestra) }}</td>
                    <td>{{ persona.AnalisisTipo }}</td>
                    <td class="text-center">
                      <v-icon color="success" v-if="persona.EsAprobado === 1"
                        >done</v-icon
                      >
                      <v-icon color="yellow" v-if="persona.EsAprobado === 0"
                        >schedule</v-icon
                      >
                    </td>
                    <td class="text-right">
                      <v-tooltip bottom v-if="persona.Archivo">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            @click.prevent="verResultados(persona)"
                          >
                            <v-icon color="primary">visibility</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver Resultados</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="persona.EsAprobado === 1 && persona.Archivo"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            class="ml-2"
                            icon
                            @click.prevent="enviarResultados(persona)"
                          >
                            <v-icon color="primary">email</v-icon>
                          </v-btn>
                        </template>
                        <span>Enviar Resultados</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="persona.EsAprobado === 1 && !persona.Archivo"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="warning"
                            >hourglass_empty</v-icon
                          >
                        </template>
                        <span>Reporte en proceso...</span>
                      </v-tooltip>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import ServicioCertificados from "../../services/certificados";
import ServicioCatalogos from "../../services/catalogos";
export default {
  name: "certificados",
  data() {
    return {
      catalogos: {
        CertificadosEstados: [],
      },
      filtros: {
        CertificadoEstadoID: null,
        FechaInicial: null,
        FechaFinal: null,
      },
      citasTodas: [],
      citaSeleccionada: {},
      expDict: {},

      citas: [],
    };
  },
  methods: {
    async enviarResultados(muestra) {
      this.confirmar(
        "Enviar Certificados",
        "Desea enviar los certificados seleccionados?"
      ).then(async () => {
        let muestras = [];
        if (muestra && this.esConvenio(muestra)) {
          muestras = muestra.Personas.filter(
            (p) => p.EsAprobado === 1 && !!p.Archivo
          ).map((p) => {
            return {
              MuestraDetalleID: p.MuestraDetalleID,
            };
          });
        } else if (muestra) {
          muestras.push({
            MuestraDetalleID: muestra.MuestraDetalleID,
          });
        } else {
          this.citasSeleccionadas.forEach((m) => {
            if (this.esConvenio(m)) {
              muestras.push(
                m.Personas.filter((p) => p.EsAprobado === 1 && !!p.Archivo).map(
                  (p) => {
                    return {
                      MuestraDetalleID: p.MuestraDetalleID,
                    };
                  }
                )
              );
            } else {
              muestras.push({
                MuestraDetalleID: m.MuestraDetalleID,
              });
            }
          });
        }
        const res = await ServicioCertificados.enviarCertificados(muestras);
        if (res.data.result === 1) {
          this.$root.mensajeExito =
            "Los certificados se enviaron correctamente";
          await this.obtenerMuestras();
        } else {
          this.$root.mensajeError = res.data.message;
        }
      });
    },
    esConvenio(muestra) {
      return muestra.Personas && muestra.Personas.length > 1;
    },
    async verResultados(muestra) {
      window.open(this.config.RutaResultados + muestra.Archivo, "_blank");
    },
    seleccionCambiada() {},
    seleccionarCita(cita, ev) {
      const clase = ev.target.classList.value;
      if (clase.indexOf("v-input") > -1 || clase.indexOf("v-icon") > -1) {
        return;
      }
      this.$set(this.expDict, cita.CitaID, !this.expDict[cita.CitaID]);
    },
    async obtenerMuestras() {
      let resCitas = await ServicioCertificados.reporteEnvio({
        ...this.filtros,
        FechaFinal: this.filtros.FechaFinal + "T23:59:59",
      });
      this.citasTodas = resCitas.data.data.Table0;
      this.citas = this.agruparCitas();
    },
    agruparCitas() {
      let citas = this.citasTodas;
      let res = [];
      for (let i = 0; i < citas.length; i++) {
        const cita = res.find(
          (c) =>
            c.CitaID === citas[i].CitaID &&
            c.ConvenioNombre === citas[i].ConvenioNombre
        );
        if (cita) {
          cita.Personas.push({
            ...citas[i],
          });
        } else {
          res.push({
            ...citas[i],
            Personas: [{ ...citas[i] }],
            Expandido: false,
          });
        }
      }
      return res;
    },
    async obtenerCatalogos() {
      const res = await ServicioCatalogos.getCertificadosEstados();
      this.catalogos.CertificadosEstados = res.data.data.Table0;
      if (this.catalogos.CertificadosEstados.length) {
        this.filtros.CertificadoEstadoID = this.catalogos.CertificadosEstados[0].CertificadoEstadoID;
      }
    },
  },
  computed: {
    citasSeleccionadas() {
      return this.citas.filter((c) => c.Seleccionado);
    },
  },
  async mounted() {
    const hoy = this.fechaPicker(this.$root.hoy);
    let inicial = new Date();
    inicial.setDate(inicial.getDate() - 14);
    inicial = this.fechaPicker(inicial);
    this.filtros.FechaInicial = inicial;
    this.filtros.FechaFinal = hoy;
    await this.obtenerCatalogos();
    await this.obtenerMuestras();
  },
};
</script>

<style>
.subtabla {
  background: #f3f3f3;
}
</style>
